const isSecure = () =>
  typeof window !== 'undefined' && window.isSecureContext === true

const hasModernClipboard = () =>
  typeof navigator !== 'undefined' &&
  typeof navigator.clipboard?.writeText === 'function'

const modernCopy = (text: string) => navigator.clipboard.writeText(text)

const legacyCopy = (text: string) =>
  new Promise<void>((resolve, reject) => {
    try {
      const textarea = document.createElement('textarea')
      Object.assign(textarea.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        opacity: '0',
      })
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()

      const ok = document.execCommand('copy')
      document.body.removeChild(textarea)

      ok ? resolve() : reject(new Error('execCommand returned false'))
    } catch (err) {
      reject(err)
    }
  })

const attempt = (...fns: Array<() => Promise<void>>) =>
  fns.reduce((prev, fn) => prev.catch(() => fn()), Promise.reject<void>())

export const copyToClipboard = (text: string): Promise<void> =>
  attempt(
    () =>
      hasModernClipboard() && isSecure() ? modernCopy(text) : Promise.reject(),
    () => legacyCopy(text)
  )
